import { render, staticRenderFns } from "./ChipUserWithMenu.vue?vue&type=template&id=b1372b32&"
import script from "./ChipUserWithMenu.vue?vue&type=script&lang=ts&"
export * from "./ChipUserWithMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports